import React from "react";

export default function CityTicker({ T, cities }) {
  const list = [...cities, ...cities, ...cities];
  return (
    <div style={{
      overflow: "hidden", borderTop: `1px solid ${T.border}`, borderBottom: `1px solid ${T.border}`,
      backgroundColor: T.bgElev
    }}>
      <div style={{
        display: "flex", whiteSpace: "nowrap",
        animation: "bp_ticker 60s linear infinite",
        paddingTop: 16, paddingBottom: 16
      }}>
        {list.map((c, i) => (
          <span key={i} style={{
            display: "inline-flex", alignItems: "center",
            fontFamily: "ui-monospace, SFMono-Regular, Menlo, Consolas, monospace",
            fontSize: "clamp(1.5rem, 3vw, 2.5rem)", fontWeight: 300, letterSpacing: "0.08em",
            color: T.text, paddingLeft: "3vw", paddingRight: "3vw"
          }}>
            {c}
            <span style={{
              display: "inline-block", width: 8, height: 8, borderRadius: "50%",
              backgroundColor: T.amber, marginLeft: "3vw"
            }} />
          </span>
        ))}
      </div>
    </div>
  );
}
